import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import useAuthContext from "../../hooks/useAuthContext";
import { AuthStatus } from "../../reducers/auth/authReducer";
import useHasPermissions from "../../hooks/useHasPermissions";

const ProtectedRoute = ({
  component: Comp,
  path,
  permissions,
  hasAny,
  additionalCheck,
  ...rest
}) => {
  const { hasPermissions } = useHasPermissions();
  const { authReducer } = useAuthContext();
  const [authState] = authReducer;

  const isAuthorized = () => {
    const permissionCheck =
      permissions === undefined ||
      permissions.length === 0 ||
      hasPermissions(permissions, hasAny ?? false);

    const onePassCheck = typeof additionalCheck === "function" ? additionalCheck() : false;
    
    return permissionCheck || onePassCheck;
  };

  return (
    <Route
      path={path}
      {...rest}
      render={props => {
        if (authState.authStatus === AuthStatus.UNAUTHENTICATED) {
          return <Redirect to="/login" />;
        } else if (isAuthorized()) {
          return <Comp {...props} />;
        } else {
          return <Redirect to={`/home`} />;
        }
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  hasAny: PropTypes.bool,
  additionalCheck: PropTypes.func
};

export default ProtectedRoute;
